export const downloadFile = (base64: string, fileName: string) => {
  // Decode base64
  const byteCharacters = atob(base64);

  // Convert to byte array
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);

  // Create Blob (PDF in your case)
  const blob = new Blob([byteArray], { type: 'application/pdf' });

  // Create download link
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;

  document.body.appendChild(link);
  link.click();

  // Cleanup
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const openPdfInNewTab = (blob: Blob) => {
  const url = window.URL.createObjectURL(blob);
  window.open(url, '_blank', 'noopener,noreferrer');
  // Defer revoke so the new tab has time to load the blob URL before it's freed.
  setTimeout(() => window.URL.revokeObjectURL(url), 10_000);
};
